import { render, staticRenderFns } from "./RechargeList.vue?vue&type=template&id=054dd844&scoped=true"
import script from "./RechargeList.vue?vue&type=script&lang=js"
export * from "./RechargeList.vue?vue&type=script&lang=js"
import style0 from "./RechargeList.vue?vue&type=style&index=0&id=054dd844&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054dd844",
  null
  
)

export default component.exports